<ngb-timepicker [(ngModel)]="model" [meridian]="true"></ngb-timepicker>
